import ChatDisabled from "discourse/plugins/chat/discourse/components/chat/disabled";

export default <template><ChatDisabled /></template>
